// extracted by mini-css-extract-plugin
export var container = "_dy-0";
export var icon = "_dy-1";
export var text = "_dy-2";